import { render, staticRenderFns } from "./400backgroundDetail.vue?vue&type=template&id=33b82c07&"
import script from "./400backgroundDetail.vue?vue&type=script&lang=js&"
export * from "./400backgroundDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports